import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" />;
  }

  try {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;

    if (decoded.exp && decoded.exp < currentTime) {
      localStorage.clear();
      alert('Your session has expired. Please log in again.');
      return <Navigate to="/login" />;
    }

    return children;
  } catch (error) {
    console.error('Invalid token format:', error);
    localStorage.clear();
    return <Navigate to="/login" />;
  }
};

export default PrivateRoute;
